type Props = {
  children: React.ReactNode
  radius?: 'sm' | 'md' | 'lg'
  className?: string
  variant?: 'primary' | 'secondary' | 'active'
  padding?: 'none' | 'xs' | 'sm' | 'rsm' | 'md' | 'lg'
}

export const BaseCard = ({ children, radius, className, variant = 'primary', padding }: Props) => {
  const variantClasses =
    variant === 'primary'
      ? 'border border-card-border dark:border-card-border-dark'
      : variant === 'secondary'
        ? 'border border-card-border dark:border-card-border-dark dark:bg-card-background'
        : 'bg-light-purple dark:bg-dark-purple'

  const radiusClasses = {
    sm: 'rounded-[8px]',
    md: 'rounded-[16px]',
    lg: 'rounded-[24px]',
  }[radius || 'md']

  const paddingClasses = {
    none: '',
    xs: 'p-4',
    sm: 'py-6 px-4',
    rsm: 'py-4 px-6',
    md: 'py-8 px-6',
    lg: 'py-5 px-5 md:p-8',
    xl: 'p-10',
  }[padding || 'sm']

  return (
    <div className={`${variantClasses} ${radiusClasses} ${className} ${paddingClasses}`}>
      {children}
    </div>
  )
}
